import { QUERIES_ADMIN, useGenerateSupplierTransaction } from '@/services'
import { SupplyOrderProps } from '@/types'
import { useQueryClient } from '@tanstack/react-query'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { onErrorMessage } from '@/helpers'
import { ROUTES_ADMIN } from '@/router'
import { TableSupplyOrder } from '../components'
import { GenerateSupplierOrderButton } from './components'
import { checkIfCheckedSupplierOrdersIsValid } from './tab-supply-payment-required.constants'

export const TabSupplyPaymentRequired = () => {
  const { t } = useTranslation('screenSupplierOrderManagementPage')

  const [checkedSupplierOrders, setcheckedSupplierOrders] = useState<
    Record<string, SupplyOrderProps>
  >({})

  const checkedSupplierOrdersUuidsArray = useMemo(
    () => Object.keys(checkedSupplierOrders),
    [checkedSupplierOrders],
  )

  const queryClient = useQueryClient()

  const { mutateAsync, isPending } = useGenerateSupplierTransaction()

  const onGenerateSupplierTransaction = async () => {
    const supplyOrders = Object.keys(checkedSupplierOrders).map(
      (key) => checkedSupplierOrders[key].reference || '',
    )

    const response = await mutateAsync({ supplyOrders })

    if (response.success) {
      setcheckedSupplierOrders({})
      queryClient.invalidateQueries({
        queryKey: [QUERIES_ADMIN.SUPPLIER_ORDER.module],
      })
      window.open(
        `${ROUTES_ADMIN.SUPPLY.ORDER_MANAGEMENT.SUPPLIER_TRANSACTION.fullPath()}?search=${response.data?.reference}&uuid=${response.data?.uuid}`,
        '_self',
      )
      return null
    }

    onErrorMessage(
      t('tableSupplyPaymentRequiredErrorTitle'),
      t('tableSupplyPaymentRequiredErrorDescription'),
    )
  }

  const onHandleToggleSupplierOrder = (record: SupplyOrderProps) => {
    if (checkedSupplierOrders[record.uuid || '']) {
      setcheckedSupplierOrders((oldCheckedSaleOrders) => {
        const newCheckedSaleOrders = { ...oldCheckedSaleOrders }
        delete newCheckedSaleOrders[record.uuid || '']
        return newCheckedSaleOrders
      })
    } else {
      setcheckedSupplierOrders({
        ...checkedSupplierOrders,
        [record.uuid || '']: record,
      })
    }
  }

  const isValidCheckedSupplierOrders = useMemo(
    () => checkIfCheckedSupplierOrdersIsValid(checkedSupplierOrders),
    [checkedSupplierOrders],
  )

  return (
    <>
      <TableSupplyOrder
        onSelectedSupplierOrdersChange={onHandleToggleSupplierOrder}
        selectedSupplierOrders={checkedSupplierOrdersUuidsArray}
        filters={{ payments_Status: 'payment_required' }}
        hiddenAppliedFilters={['payments_Status']}
        withFilterByExpectedPaymentDate
      />

      <GenerateSupplierOrderButton
        isValid={isValidCheckedSupplierOrders}
        isOpen={Object.keys(checkedSupplierOrders).length > 0}
        isPlural={Object.keys(checkedSupplierOrders).length > 1}
        onGenerateSupplierTransaction={onGenerateSupplierTransaction}
        isLoading={isPending}
      />
    </>
  )
}
